import { createStyles } from '@zn-material-ui'

export default createStyles({
  root: {
    margin: 0,
    padding: 0,
    height: 50,
  },
  closeButton: {
    position: 'absolute',
    right: 10,
    top: 10,
    color: 'rgba(54,60,70,0.20)',
  },
})
